import { RoundedCheckboxProps } from './rounded-checkbox.props';
import LazyLoad from 'react-lazyload';

export const RoundedCheckboxMolecule = (props: RoundedCheckboxProps) => {
  return (
    <label
      data-cy="rounded-checkbox-molecule"
      onClick={props.setAsChecked}
      className={`block cursor-pointer relative pl-10 my-2 text-waldo-blue ${props.labelClass}`}
    >
      <input
        className="hidden w-0 h-0"
        type="radio"
        value={props.value}
        id={props.name}
        name={props.name}
        onChange={props.onClick}
        onFocus={props.onFocus}
        onBlur={props.onBlur}
      />
      {props.labelImage ? (
        <LazyLoad offset={20}>
          <img src={props.labelImage} alt={props.label} className="h-5  " />
        </LazyLoad>
      ) : (
        props.label
      )}
      <span className="checkbox absolute left-0 top-0 w-5 h-5 mt-0.5 rounded-full border border-waldo-blue">
        {props.checked && (
          <span className="absolute border-2 border-white w-full h-full bg-waldo-blue rounded-full" />
        )}
      </span>
    </label>
  );
};
